import { ShapeTool } from ".";

const fabric = require("../fabric").fabric;

export class CalibratorTool extends ShapeTool {

  buildShape(pointer, origX, origY) {
    let styleModule = this.imageEditor.getModule("style");

    return new fabric.Line([pointer.x, pointer.y, pointer.x, pointer.y], {
      fill: styleModule.fillColor,
      stroke: styleModule.fillColor,
      strokeWidth: styleModule.strokeSize,
      transparentCorners: false,
      selectable: false
    });
  }

  mouseDrag(line, pointer, origX, origY) {
    line.set({x2:pointer.x,y2:pointer.y});
  }

  shapePlaced(line) {
    var length = Math.sqrt(Math.pow(line.width, 2) + Math.pow(line.height, 2));
    console.log("Width: " + line.width + " Height: " + line.height);
    console.log("Length: " + length);
    this.imageEditor.canvas.renderAll();
    this.imageEditor.showMesurementCalibrator(length, line);
  }

}